export default __webpack_public_path__ + "static/media/nav-desktop.8da158a1.webp";